import React from "react";
import VendorEditContent from "./components/OfficerVendorEditContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";

const VendorEdit = () => {
  return (
    <div>
      <TitleHolder>Vendor Edit</TitleHolder>
      <StepperContentHolder>
        <VendorEditContent />
      </StepperContentHolder>
    </div>
  );
};

export default VendorEdit;
